(() => {
  const init = () => {
    const root = document.body;
    if (!root || root.dataset.lpcReady) return;
    root.dataset.lpcReady = 'true';
    const menu = document.querySelector('.lc-mobile');
    menu?.addEventListener('click', event => {
      if (event.target.closest('a')) menu.open = false;
    });
    root.addEventListener('keydown', event => {
      if (event.key === 'Escape' && menu?.open) {
        menu.open = false;
        menu.querySelector('summary').focus();
      }
    });
    if ('IntersectionObserver' in window && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('lc-seen');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12 });
      root.querySelectorAll('.lc-reveal').forEach(element => observer.observe(element));
    }
    const video = root.querySelector('video');
    // Native controls work without JavaScript. Stop playback in background tabs.
    const onVisibility = () => { if (document.hidden) video?.pause(); };
    document.addEventListener('visibilitychange', onVisibility);
    document.addEventListener('shopify:section:unload', event => {
      if (event.target.contains(root)) document.removeEventListener('visibilitychange', onVisibility);
    }, { once: true });
  };
  init();
  document.addEventListener('shopify:section:load', init);
})();
